import { Building } from 'src/api/types';

import { BuildingsState } from './types';

export const emptyBuildingsByTown = new Map<number, Set<number>>();

export const emptyBuildingsById = new Map<number, Building>();

export const emptyCurrentRequests = new Set<number>();

export const initialState: BuildingsState = {
  loading: false,
  currentRequests: emptyCurrentRequests,
  buildingsByTowns: emptyBuildingsByTown,
  buildingsById: emptyBuildingsById,
};
